exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".virtual-scroller[data-v-303cd025]:not(.page-mode){overflow-y:auto}.item-container[data-v-303cd025]{box-sizing:border-box;width:100%;overflow:hidden}.items[data-v-303cd025]{width:100%}.resize-observer[data-v-6a22d6d2]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.test h1[data-v-5ee0142a]{color:#40b883}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-virtual-scroller/dist/vue-virtual-scroller.css
// module id = 201
// module chunks = 11